import Store from "@/store/index.js";
import axios from "axios";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
const domain = Store.state.domain;

export default {
  async ObtenerDireccion(datos, docid, pagina) {
    var formData = new FormData();
    formData.append("nrreporte", datos.nrreporte);
    formData.append("svindice", datos.svindice);
    formData.append("docid", docid);
    formData.append("pagina", pagina);
    let response = await axios.post(
      `${domain.domainNameForApi}Documentos/ObtenerDireccion`,
      formData
    );
    return response.data;
  },
  async AlmacenarVisitas(datos) {
    let response = await axios.post(
      `${domain.domainNameForApi}Documentos/AlmacenarVisitas`,
      datos
    );
    return response.data;
  },
  async ObtenerCatalogoDocumentos(vm, datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    vm.axios
      .post(
        `${vm.domain.domainNameForApi}Archivos/ObtenerCatalogoDocumentos`,
        datosReporte
      )
      .then((response) => {
        vm.tipoDoc.opcionesDoc = response.data;
      });
  },
  ChunkUpload(vm, data, file) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}Archivos/ChunkUpload`, data, file)
      .then((response) => response.data);
  },
  async CommitUpload(vm, data) {
    let formData = new FormData();
    formData.append("data", data);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/CommitUpload`,
      formData
    );
    return response.data;
  },
  SubirArchivo(vm, datos) {
    return vm.axios
      .post(`${vm.domain.domainNameForApi}Archivos/SubirArchivo`, datos, {
        headers: { "content-type": "multipart/form-data" },
      })
      .then((response) => response.data);
  },
  async ObtenerCatalogoLlamadas(vm) {
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Archivos/CatalogoLlamadas`
    );
    vm.tipoLlamada.opcionesLlamada = response.data;
  },
  async DescargaZip(datos, docid, dodescrip) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("docid", docid);
    datosReporte.append("dodescrip", dodescrip);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/DescargaArchivoZIP`,
      datosReporte,
      { responseType: "blob" }
    );
    return response.data;
  },
  async CalificarDoc(vm, datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("docid", vm.docid);
    datosReporte.append("docestatus", vm.respuesta);
    datosReporte.append("observaciones", vm.comentarios);
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Archivos/CalificarDoc`,
      datosReporte
    );
    return response;
  },
  async ObtenerCatalogoDocs(vm, datos) {
    var datosReporte = new FormData();
    datosReporte.append("tipo", vm.tipo);
    datosReporte.append("aiclave", vm.aiclave);
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("doclave", vm.doclave);
    await axios
      .post(
        `${domain.domainNameForApi}Archivos/ObtenerCatalogoDocs`,
        datosReporte
      )
      .then((response) => {
        vm.tipoDoc.opcionesDoc = response.data;
      });
  },
  async RestablecerCalificacionDoc(datos, docid) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("docid", docid);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/RestablecerCalificacionDoc`,
      datosReporte
    );
    return response.data;
  },
  async MostarDocNoConformes(datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/MostarDocNoConformes`,
      datosReporte
    );
    return response.data[0];
  },
  async ObtenerUsuarios(datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/ObtenerUsuarios`,
      datosReporte
    );
    return response.data;
  },
  async CompartirVideo(datos, uslogin, dias, docid) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("uslogin", uslogin);
    datosReporte.append("docid", docid);
    datosReporte.append("dias", dias);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/CompartirVideo`,
      datosReporte
    );
    return response.data;
  },
  async ObtenerPermiso(datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/ObtenerPermiso`,
      datosReporte
    );
    return response.data;
  },
  async ObtenerInfoVideo(docid) {
    var datosReporte = new FormData();
    datosReporte.append("docid", docid);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/ObtenerInfoVideo`,
      datosReporte
    );
    return response.data;
  },
  async EliminarPermiso(vcid) {
    var datosVideo = new FormData();
    datosVideo.append("vcid", vcid);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/EliminarPermisoVideo`,
      datosVideo
    );
    return response.data;
  },
  async EliminarArchivo(datos, docid) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("docid", docid);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/EliminarArchivo`,
      datosReporte
    );
    return response.data;
  },
  async EstatusReporte(vm, datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/EstatusReporte`,
      datosReporte
    );
    vm.adjuntarArchivos = response.data;
  },
  async EliminarVideo(datos, docid, vidId) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("docid", docid);
    datosReporte.append("vidId", vidId);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/EliminarVideo`,
      datosReporte
    );
    return response.data;
  },
  async ObtenerCatalogoVideo(vm) {
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Archivos/CatalogoVideos`
    );
    vm.tipoVideo.opcionesVideo = response.data;
  },
  async CommitUploadVideo(vm, data) {
    let formData = new FormData();
    formData.append("data", data);
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Archivos/CommitUploadVideo`,
      formData
    );
    return response.data;
  },
  async ObtenerFormulario(vm) {
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Archivos/ObtenerFormulario`
    );
    return response.data;
  },
  async ValidacionEnvioCorreo(datos) {
    let doc = await MetodosGenerales.obtenerSessionReporte("documento");
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("docid", doc.docid);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/EnviarCorreoDoc`,
      datosReporte
    );
    return response.data;
  },
  async EnviarCorreo(datos, correo) {
    let doc = await MetodosGenerales.obtenerSessionReporte("documento");
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("tCorreoPara", correo.tCorreoPara);
    datosReporte.append("tCorreoCopiacc", correo.tCorreoCopia);
    datosReporte.append("tAsunto", correo.tAsunto);
    datosReporte.append("txtMensaje", correo.txtMensaje);
    datosReporte.append("docid", doc.docid);
    datosReporte.append("paginas", doc.paginas);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/EnviarDocumentos`,
      datosReporte
    );
    return response.data;
  },
  async DescargaMasivaZIP(datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/DescargaMasivaZIP`,
      datosReporte,
      { responseType: "blob" }
    );

    console.log("El response del service: ", response);
    return response.data;
  },
  async GenerarPDF(datos, docs) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("docs", docs);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/GenerarPDF`,
      datosReporte,
      { responseType: "blob" }
    );
    return response.data;
  },
  async Reclasificar(datos) {
    return await axios
      .post(`${domain.domainNameForApi}Archivos/Reclasificar`, datos)
      .then((response) => response.data);
  },
  async CompartirArchivos(datos, docids, fecha) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("docids", docids);
    datosReporte.append("fecha", fecha);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/CompartirArchivos`,
      datosReporte
    );
    return response.data;
  },
  async ObtenerEnlaces(datos) {
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/ObtenerEnlaces`,
      datos
    );
    return response.data;
  },
  async ObtenerContrato(ruta, nombreArchivo) {
    var formData = new FormData();
    formData.append("ruta", ruta);
    formData.append("nombreArchivo", nombreArchivo);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/ObtenerArchivo`,
      formData
    );
    return response.data;
  },
  async CatalogoConformeInconforme(tipo) {
    var formData = new FormData();
    formData.append("tipo", tipo);
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/CatalogoConformeInconforme`,
      formData
    );
    return response.data;
  },
  async CalificarLlamada(vm, datos) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("docid", vm.docid);
    datosReporte.append("docestatus", vm.respuesta);
    datosReporte.append("observaciones", vm.comentarios);
    datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());
    datosReporte.append("motivo", vm.motivo);
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Archivos/CalificarLlamada`,
      datosReporte
    );
    return response;
  },
  async RestablecerCalificacionLlamada(datos, docid) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("docid", docid);
    datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/RestablecerCalificacionLlamada`,
      datosReporte
    );
    return response.data;
  },
  async ObtenerDireccionAgentes(vm, nrreporte, svindice, docid) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", nrreporte);
    datosReporte.append("svindice", svindice);
    datosReporte.append("docid", docid);
    datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Documentos/ObtenerDireccionAgentes`,
      datosReporte
    );
    return response.data;
  },
  async ExistePDF(datos, docid) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("docid", docid);
    let response = await axios.post(
      `${domain.domainNameForApi}Documentos/ExistePDF`,
      datosReporte
    );
    return response.data;
  },
  async DividirArchivo(
    datos,
    docid,
    pagina,
    divisiones,
    doclave,
    paginasLibres
  ) {
    let divisionesNew = JSON.parse(JSON.stringify(divisiones)); // Clonar para evitar modificar el original
    divisionesNew.forEach((pdf, i) => {
      pdf.doclave = pdf.doclave?.doclave || pdf.doclave;
    });
    divisionesNew.push({
      tipoDiv: "P",
      paginas: paginasLibres,
      doclave: doclave,
      validacion: null,
      placeholder: "",
      add: true,
      remove: false,
      error: "",
      nuevo: "E",
    });

    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("docid", docid);
    datosReporte.append("pagina", pagina);
    datosReporte.append("divisiones", JSON.stringify(divisionesNew));
    datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());
    let response = await axios.post(
      `${domain.domainNameForApi}Archivos/DividirArchivo`,
      datosReporte
    );
    return response.data;
  },
  async ObtenerTranscripcion(vm, nrreporte, svindice, docid) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", nrreporte);
    datosReporte.append("svindice", svindice);
    datosReporte.append("docid", docid);
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Archivos/ObtenerTranscripcion`,
      datosReporte
    );
    return response.data;
  },
  async TranscribirLlamada(vm, datos, docid) {
    var datosReporte = new FormData();
    datosReporte.append("nrreporte", datos.nrreporte);
    datosReporte.append("svindice", datos.svindice);
    datosReporte.append("docid", docid);
    datosReporte.append("uslogin", MetodosGenerales.ObtenerUserName());
    let response = await vm.axios.post(
      `${vm.domain.domainNameForApi}Archivos/TranscribirLlamada`,
      datosReporte
    );
    return response.data;
  },
  async ObtenerEstadoProceso(vm, jobId) {
    var formData = new FormData();
    formData.append("jobId", jobId);
    let resp = await vm.axios.post(
      `${vm.domain.domainNameForApi}Archivos/EstadodelProceso`,
      formData
    );
    return resp.data;
  },
};
